import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "h-100 border-gray p-3 d-flex flex-column rounded-3"
};
var _hoisted_2 = {
  "class": "mb-3"
};
var _hoisted_3 = {
  "class": "font-size-12 font-weight-semibold"
};
var _hoisted_4 = {
  "class": "sh-color-gray-3 font-size-12"
};
var _hoisted_5 = {
  "class": "d-flex flex-column"
};
var _hoisted_6 = {
  "class": "row g-3"
};
var _hoisted_7 = {
  "class": "d-block font-weight-regular font-size-10 sh-color-gray-3"
};
var _hoisted_8 = {
  "class": "font-size-12 font-weight-semibold d-flex gap-1 align-items-center flex-wrap"
};
var _hoisted_9 = {
  key: 0,
  "class": "font-size-10 border-gray rounded-1 px-1"
};
var _hoisted_10 = {
  "class": "alert alert-info border-1 rounded-2 p-2 d-flex gap-1 align-items-start mt-3 mb-0",
  role: "alert"
};
var _hoisted_11 = {
  "class": "flex-grow-1"
};
var _hoisted_12 = {
  "class": "sh-color-gray-4 font-size-10"
};
var _hoisted_13 = {
  "class": "d-flex gap-2 mt-auto flex-wrap"
};
var _hoisted_14 = ["src"];
import { unref } from 'vue';
export default {
  __name: 'ProductExpansionIdeaCard',
  props: {
    idea: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var actionClasses = {
      primary: 'btn btn-dark-blue btn-sm rounded-2 px-2 d-flex justify-content-center align-items-center gap-1 font-size-11 flex-fill',
      secondary: 'btn btn-outline-white btn-sm rounded-2 px-2 d-flex justify-content-center align-items-center gap-1 font-size-11 flex-fill'
    };
    function resolveActionComponent(action) {
      if (action.to) {
        return 'RouterLink';
      }
      if (action.href) {
        return 'a';
      }
      return 'button';
    }
    function buildActionProps(action) {
      if (action.to) {
        return {
          to: action.to
        };
      }
      if (action.href) {
        return {
          href: action.href
        };
      }
      return {
        type: 'button'
      };
    }
    function isActionDisabled(action) {
      return Boolean(unref(action.disabled));
    }
    function resolveActionLabel(action) {
      return unref(action.label);
    }
    function resolveActionIcon(action) {
      return unref(action.icon);
    }
    function handleActionClick(action, event) {
      if (isActionDisabled(action)) {
        event.preventDefault();
        return;
      }
      if (typeof action.onClick === 'function') {
        event.preventDefault();
        action.onClick(event);
      }
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.idea.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.idea.description), 1)]), _createElementVNode("div", {
        "class": _normalizeClass(["border-top py-3", __props.idea.centerContent ? 'my-auto' : ''])
      }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.idea.metrics, function (metric) {
        return _openBlock(), _createElementBlock("div", {
          key: "".concat(__props.idea.id, "-").concat(metric.label),
          "class": "col-4"
        }, [_createElementVNode("label", _hoisted_7, _toDisplayString(metric.label), 1), _createElementVNode("div", _hoisted_8, [_createTextVNode(_toDisplayString(metric.value) + " ", 1), metric.badge ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(metric.badge), 1)) : _createCommentVNode("", true)])]);
      }), 128))]), _createElementVNode("div", _hoisted_10, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        "class": "line-height-13"
      }, [_createElementVNode("img", {
        src: "/img/v5/db_ic_idea_sm.svg"
      })], -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(__props.idea.insight), 1)])])])], 2), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.idea.actions, function (action, index) {
        return _openBlock(), _createBlock(_resolveDynamicComponent(resolveActionComponent(action)), _mergeProps({
          key: "".concat(__props.idea.id, "-").concat(index),
          ref_for: true
        }, buildActionProps(action), {
          "class": [{
            disabled: isActionDisabled(action)
          }, actionClasses[action.variant] || actionClasses.secondary],
          onClick: function onClick($event) {
            return handleActionClick(action, $event);
          }
        }), {
          "default": _withCtx(function () {
            return [_createElementVNode("img", {
              src: resolveActionIcon(action)
            }, null, 8, _hoisted_14), _createTextVNode(" " + _toDisplayString(resolveActionLabel(action)), 1)];
          }, undefined, true),
          _: 2
        }, 1040, ["class", "onClick"]);
      }), 128))])]);
    };
  }
};